<template>
    <header
        v-lazy:background-image="backgroundImage"
        class="header d-flex align-items-center"
    >
        <div class="container z-index--10">
            <div class="row">
                <div class="col-12 col-md-8 col-lg-10 offset-lg-1 mb-5">
                    <h1 class="text-center color--white">
                        {{ title }}
                    </h1>
                </div>
                <div
                    class="col-12 col-xl-10 offset-xl-1 d-md-flex justify-content-center align-items-baseline mb-4"
                >
                    <div class="header__search mb-4 pr-3 d-flex mr-5">
                        <input
                            ref="searchInput"
                            v-model="searchInput"
                            class="search__input d-inline-block"
                            type="text"
                            placeholder="Zoek op trefwoorden"
                            @keydown.enter="executeSearch"
                        />
                        <button>
                            <i class="fa fa-search" aria-hidden="true"></i>
                        </button>
                    </div>
                    <a href="#" class="btn btn--blue-7 ml-1 d-none"
                        ><span
                            >{{ linkText }} <i class="fa fa-map mx-2"></i></span
                    ></a>
                </div>
                <div
                    class="col-12 col-xl-10 offset-xl-1 d-flex justify-content-md-center align-items-center flex-wrap flex-md-nowrap"
                >
                    <span
                        class="h3 color--white mb-2 mr-md-3 text-left text-lg-right width-sm-100"
                        >Bekijk aanbod voor:</span
                    >
                    <a
                        v-for="(link, index) in links"
                        :key="index"
                        :href="link.Url"
                        :target="link.Target"
                        class="btn btn--purple-1 mb-3 mr-1"
                        ><span>
                            {{ link.Name }}
                            <i class="fas fa-arrow-right ml-2"></i></span
                    ></a>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import Axios from 'axios';

export default {
    props: {
        images: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            default: 'Verwondering ligt om iedere hoek'
        },
        linkText: {
            type: String,
            default: 'Zoeken op kaart'
        },
        links: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data: function() {
        return {
            searchInput: '',
            url: '/api/search/searchurl'
        };
    },
    computed: {
        backgroundImage() {
            let url = '';
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    url = this.$useWebP
                        ? this.images.images[1].webP
                        : this.images.images[1].src;
                    break;
                case 'md':
                    url = this.$useWebP
                        ? this.images.images[2].webP
                        : this.images.images[2].src;
                    break;
                case 'lg':
                    url = this.$useWebP
                        ? this.images.images[3].webP
                        : this.images.images[3].src;
                    break;
                default:
                    url = this.$useWebP
                        ? this.images.images[0].webP
                        : this.images.images[0].src;
                    break;
            }
            return url;
        }
    },
    methods: {
        executeSearch() {
            Axios.get(this.url)
                .then(response => {
                    window.location.href =
                        response.data + '?searchTerm=' + this.searchInput;
                })
                .catch(() => false);
        }
    }
};
</script>

<style lang="scss" scoped>
.header {
    position: relative;
    min-height: calc(100vh - 38px);
    width: 100%;
    padding-bottom: 15%;
    padding-top: 70px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    color: $black;

    @include media-breakpoint-up(sm) {
        padding-top: 80px;
    }

    @include media-breakpoint-up(lg) {
        padding-bottom: 10%;
        height: 800px;
    }

    &:after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        width: 100%;
        padding-top: 65%;
        background-size: cover;
        background-position: 100%;
        background-repeat: no-repeat;
        background-image: url(/Content/img/wave-icons.svg);
        pointer-events: none;

        @include media-breakpoint-up(sm) {
            padding-top: 40%;
        }

        @include media-breakpoint-up(md) {
            padding-top: 30%;
        }

        @include media-breakpoint-up(lg) {
            padding-top: 24%;
        }
    }

    &:before {
        content: '';
        background-color: rgba(65, 65, 65, 0.3);
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        pointer-events: none;
    }
}

.header h1 {
    line-height: 1.1;
    font-size: 2.375rem;

    @include media-breakpoint-up(md) {
        line-height: 1.2;
        font-size: 3rem;
    }

    @include media-breakpoint-up(lg) {
        line-height: 1.3;
        font-size: 3.75rem;
    }
}

.header .btn {
    padding: 5px 20px 5px 40px;

    @include media-breakpoint-up(md) {
        min-width: 170px;
        flex: 0 1 auto;
    }
}

.header .btn i {
    font-size: 1.3rem;
}

.header__search {
    background-color: $gray-5;
    height: 56px;
    max-width: 525px;
    width: 100%;
    border-radius: 28px;
    border: 0;
    font-size: 1.125rem;
    color: $gray-4;
    padding: 0 20px;
    flex: 1 1 auto;
}

.header__search button {
    border: 0;
    line-height: 0;
    background: none;
    flex: 0 1 auto;
    justify-self: end;
}

.header__search input {
    display: none;
    border: 0;
    padding: 0 10px 0 0;
    background: none;
    height: 100%;
    flex: 1 1 auto;

    @include media-breakpoint-up(lg) {
        padding: 0 20px 0 30px;
        display: inline-block;
    }

    &::placeholder {
        color: $gray-4;
    }

    &:focus {
        outline: none;
    }
}

.header__search i {
    color: $blue-7;
    font-size: 1.5rem;
}
</style>
